function TradeVisionProfilesVisual() {
  return (
    <div className="w-full rounded-[24px] border border-border-subtle bg-[#121a28] p-4 md:p-5 overflow-hidden">
      <div className="flex flex-col gap-3">
        <div>
          <p className="text-micro font-medium uppercase tracking-[0.18em] text-link-blue">
            Player intelligence
          </p>
          <h3 className="mt-2 text-left text-card-title text-primary">
            Customer groups, value, and behaviour over time built on TradeVision
          </h3>
        </div>

        <div className="grid gap-3 sm:grid-cols-3">
          {[
            ['Customer groups', '6 active'],
            ['At-risk movement', '2 rising'],
            ['Customer value', 'Priority ranked']
          ].map(([label, value]) => (
            <div
              key={label}
              className="rounded-[18px] border border-border-subtle bg-white/[0.025] px-4 py-3"
            >
              <p className="text-micro font-medium uppercase tracking-[0.14em] text-muted">
                {label}
              </p>
              <p className="mt-2 text-sm font-semibold text-primary">{value}</p>
            </div>
          ))}
        </div>

        <div className="grid flex-1 min-h-0 gap-3 lg:grid-cols-[0.95fr_1.05fr]">
          <div className="rounded-[20px] border border-border-subtle bg-white/[0.025] p-3.5">
            <div className="flex items-center justify-between gap-3">
              <p className="text-sm font-semibold text-primary">Customer groups</p>
              <span className="rounded-full bg-secondary/10 px-2.5 py-1 text-micro font-medium text-secondary">
                Action ready
              </span>
            </div>
            <div className="mt-3 space-y-2">
              {[
                ['High-value cohort', 'Retention priority'],
                ['At-risk segment', 'Activity slipping'],
                ['Reactivation group', 'Returning this week']
              ].map(([label, detail]) => (
                <div
                  key={label}
                  className="rounded-2xl border border-border-subtle bg-[#0f1724] px-3 py-2.5"
                >
                  <p className="text-sm font-semibold text-primary">{label}</p>
                  <p className="mt-1 text-micro leading-6 text-muted">{detail}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid min-h-0 gap-3 auto-rows-min">
            <div className="rounded-[20px] border border-border-subtle bg-white/[0.025] p-3.5">
              <p className="text-micro font-medium uppercase tracking-[0.14em] text-muted">
                Behaviour over time
              </p>
              <div className="mt-3 space-y-3">
                {[
                  ['High-value cohort', 'stable', 'w-[82%]'],
                  ['At-risk segment', 'rising', 'w-[56%]'],
                  ['Reactivation group', 'recovering', 'w-[68%]']
                ].map(([label, trend, width]) => (
                  <div key={label}>
                    <div className="flex items-center justify-between gap-3 text-sm">
                      <p className="font-semibold text-primary">{label}</p>
                      <span className="text-muted">{trend}</span>
                    </div>
                    <div className="mt-2 h-2 rounded-full bg-[#0f1724]">
                      <div className={`h-full rounded-full bg-secondary ${width}`} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="rounded-[20px] border border-border-subtle bg-white/[0.025] p-3.5">
              <div className="flex items-center justify-between gap-3">
                <p className="text-sm font-semibold text-primary">Follow-up starting points</p>
                <span className="rounded-full bg-secondary/10 px-2.5 py-1 text-micro font-medium text-secondary">
                  CRM / RG
                </span>
              </div>
              <div className="mt-3 flex flex-wrap gap-2">
                {['Product planning', 'CRM execution', 'RG follow-up'].map((item) => (
                  <span
                    key={item}
                    className="rounded-full border border-border-subtle bg-[#0f1724] px-3 py-2 text-sm font-medium text-primary"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TradeVisionProfilesVisual
